import { TooltipIconButton } from './Components'
import { QuestionMark } from './icons/responsive-icons'

const MoreInfo = ({ tooltipText }) => (
  <TooltipIconButton tooltipText={tooltipText} round={true}>
    <QuestionMark />
  </TooltipIconButton>
)

export default MoreInfo
